import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid-pro';
import { usePayRulesQuery } from './usePayRulesQuery';
import { usePayRulesTableState } from './usePayRulesTableState';

export const usePayRulesTable = () => {
    const { t } = useTranslation();
    const { rows, setRows, loading, setLoading, loadData } = usePayRulesQuery();
    const { contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected } = usePayRulesTableState();

    const columns: GridColDef[] = [
        { field: 'name', headerName: t('settings.pay_rules.table.columns.name'), flex: 1 },
        { field: 'fixed_rule_name', headerName: t('settings.pay_rules.table.columns.fixed_rule'), flex: 1 },
        { field: 'work_rule_default_name', headerName: t('settings.pay_rules.table.columns.work_rule_default'), flex: 1 },
    ];

    const reloading = useCallback(() => {
        const permissions = JSON.parse(localStorage.getItem('permissions') || '[]') as string[];
        const canReadPayRules = permissions.includes('timekeeper.PayRules');

        if (canReadPayRules) {
            loadData().finally(() => {
                setContextMenu(null);
                cleanSelected();
            });
        } else {
            setRows([]);
            setLoading(false);
        }
    }, [cleanSelected, loadData, setContextMenu, setLoading, setRows]);

    return { columns, rows, setRows, loading, setLoading, loadData, contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected, reloading };
};
